<template>
  <div align="center">
    <h1>404</h1>
    <h3>Страница не найдена. Перейти на сайт <a href="https://www.medicina.ru/kontakty/">Медицины</a></h3>

  </div>
</template>

<script>

export default {
  name: 'error404'
}
</script>
